import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { listResources } from '../../content/resources/catalog';
import styles from './Resources.module.css';

export const ResourcesLibraryPage: React.FC = () => {
  const { isAuthenticated } = useUser();
  const navigate = useNavigate();
  const items = listResources({ includeAuthenticated: isAuthenticated });

  return (
    <main className={styles.page} data-testid="resources-library">
      <header className={styles.header}>
        <p className={styles.eyebrow}>Resources</p>
        <h1 className={styles.title}>Articles &amp; guides</h1>
        <p className={styles.lede}>
          Methodology, control surfaces, and demand education — some open to guests, some for members.
        </p>
      </header>

      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.id}>
            <Link className={styles.card} to={`/resources/${item.slug}`}>
              <span className={styles.kind}>{item.kind}</span>
              <span className={styles.cardTitle}>{item.title}</span>
              <span className={styles.cardSummary}>{item.summary}</span>
              {item.visibility === 'authenticated' ? (
                <span className={styles.badge}>Members</span>
              ) : (
                <span className={styles.badgePublic}>Open</span>
              )}
            </Link>
          </li>
        ))}
      </ul>

      {!isAuthenticated ? (
        <p className={styles.memberHint}>
          <button type="button" className={styles.linkBtn} onClick={() => navigate('/login?next=/resources')}>
            Sign in
          </button>{' '}
          to see member-only articles.
        </p>
      ) : null}
    </main>
  );
};
